/*
 * @Description: 收款报表
 * @Author: 李镇鹏
 * @Date: 2019-06-24 10:41:42
 * @LastEditTime: 2019-07-01 19:54:04
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Divider, message, Popconfirm} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import Detail from './components/Detail';
import { post, config, transterQuery } from '../../axios';
import { handleExportParams } from '../../utils';
import moment from "moment";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                buildingName: '',
                roomNo: '',
                projectName: '',
                merchantName: '',
                startDate: '',
                endDate: '',
                mustPayDate:'',
                customerKey:'',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额,
            receivedMoney: 0, //已收金额
            historyBillMoney: 0,// 历史迁移金额
            uncollectedMoney: 0,// 未收金额
            showDetailModal: false, //显示详情
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            current = values.current
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true,current });

        post({ url: config.API_device_findReportTradeRecordPage, data }).then(res => {
            this.setState({ tableTotalMny: res.money,receivedMoney: res.receivedMoney,historyBillMoney: res.historyBillMoney,uncollectedMoney:res.uncollectedMoney,tableTotal: res.total, tableData: res.tradeRecord, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleDetail = (e, msg) => { //详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPack(msg);
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            historyBillMoney,
            uncollectedMoney,
            receivedMoney,
            showDetailModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton authkey="z-7-1" type="primary" icon="export" href={`${config.API_device_tradeRecordListExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns({ handleDetail: this.handleDetail })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    vacantBillMoney={historyBillMoney}
                    uncollectedMoney={uncollectedMoney}
                    receivedMoney={receivedMoney}
                    current={current}
                    onChange={this.handleSearch}
                />

                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={()=>this.setState({ showDetailModal: false })}
                />
            </PageWrap>
        )
    }
}

const searchData = () => {
    let data = [
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDateStr',options:{initialValue:moment(new Date())}, mode:"multiple"  },
            attribute: { placeholder: '请选择应收月份开始',type:'month',format:"YYYY-MM", allowClear:false,style: { width: "172.7px" } },
        },
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDateEnd',options:{initialValue:moment(new Date())}, mode:"multiple"  },
            attribute: { placeholder: '请选择应收月份结束',type:'month',format:"YYYY-MM", allowClear:false,style: { width: "172.7px" } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectName' },
            attribute: { placeholder: '请输入项目', style: { width: '175px' } },
        }

    ];
    return data;
};

const columns = ({ handleDetail }) => [
    {
        title: '应收月份',
        dataIndex: '应收月份',
        render:(text,record)=>`${record.mustPayDate}`
    },
    {
        title: '项目',
        dataIndex: 'projectName'
    },
    {
        title: '当月应收金额（元）',
        dataIndex: 'amountReceivable',
        render(text, record, index) {
            //if (record.amountReceivable > 0) {
            //     return <a><span className="showClickDetail" onClick={(e) => {
            //         handleDetail(e, {
            //             mustPayDate: record.mustPayDate,
            //             // endDate: record.mustPayDate,
            //             buildingName: record.buildingName,
            //             roomNo: record.roomNo,
            //             houseId: record.houseId,
            //             projectId: record.projectId,
            //             customerId:record.customerId,
            //             customerName:record.customerName,
            //             receiveStatus: ''
            //
            //         })
            //     }}>{record.amountReceivable}</span></a>
            // } else {
                return <span>
                <div>{record.amountReceivable}</div>
                </span>
           // }
        }
    },
    {
        title: '实际应收金额（元）',
        dataIndex: 'receivedMoney',
        render(text, record, index) {
            // if (record.receivedMoney > 0) {
            //     return <a><span className="showClickDetail" onClick={(e) => {
            //         handleDetail(e, {
            //             houseId: record.houseId,
            //             customerId:record.customerId,
            //             mustPayDate: record.mustPayDate,
            //             receiveStatus: 3,
            //             buildingName: record.buildingName,
            //             roomNo: record.roomNo,
            //         })
            //     }}>{record.receivedMoney}</span></a>
            // } else {
                return <span>
                <div>{record.receivedMoney}</div>
                </span>
           // }
        }
    },
    {
        title: '当月空置账单金额（元）',
        dataIndex: 'historyBillMoney',
        render(text, record, index) {
         //   if (record.historyBillMoney > 0) {
            //     return <a><span className="showClickDetail" onClick={(e) => {
            //         handleDetail(e, {
            //             houseId: record.houseId,
            //             customerId:record.customerId,
            //             mustPayDate: record.mustPayDate,
            //             receiveStatus: 10,
            //             buildingName: record.buildingName,
            //             roomNo: record.roomNo,
            //         })
            //     }}>{record.historyBillMoney}</span></a>
            // } else {
                return <span>
                <div>{record.historyBillMoney}</div>
                </span>
           // }
        }
    },
    { title: '操作', dataIndex: 'action', render: (text, record) => {
                        return <a><span className="showClickDetail" onClick={(e) => {
                             handleDetail(e, {
                                 houseId: record.houseId,
                                 customerId:record.customerId,
                                 mustPayDate: record.mustPayDate,
                                 projectKeyword: record.projectName,
                                 writeOff: 1,
                                roomNo: record.roomNo
                            })
                        }}>查看详情</span></a>;
        }}

];


// WEBPACK FOOTER //
// ./src/page/DeviceBillReport/Payment.js